// import { createApp } from 'vue';
import { createApp } from 'vue/dist/vue.esm-bundler';
import store from '@/_modules/store';
import CommonHeader from '@/_components/CommonHeader';
import CommonFooter from '@/_components/CommonFooter';
import CommonModalMenu from '@/_components/CommonModalMenu';
import ContactForm from '@/_components/ContactForm';
import Recommends from '@/_components/Recommends';
import Loading from '@/_components/Loading';
import FloatingButtons from '@/_components/FloatingButtons';
import Mv from '@/_components/Mv';
import ToggleInterview from '@/_components/ToggleInterview';
import PropertyList from '@/_components/PropertyList';

import 'url-search-params-polyfill';
import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';

import { gsap, Quart } from 'gsap/all';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default class pageTop {
  constructor() {
    this.isFirst = false;
    this.init();
  }

  init() {
    const EventHandling = {
      components: {
        CommonHeader,
        CommonFooter,
        CommonModalMenu,
        ContactForm,
        Loading,
        FloatingButtons,
        Mv,
        Recommends,
        ToggleInterview,
        PropertyList,
      },
      data() {
        return {
        }
      },
      mounted() {
        const swiper = new Swiper('.swiper--feature', {
          modules: [Pagination, Autoplay, EffectFade],
          autoplay: {
            delay: 4000,
          },
          loop: true,
          speed: 1000,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          pagination: {
            el: '.swiper-pagination',
          },
        });

        this.$nextTick(this.start);
      },
      methods: {
        start() {
          // ローディング画面 消す
          this.$store.commit('showLoad', false);
          this.$store.commit('showFloating', true);
          this.$store.commit('showMenu', true);
          this.$store.commit('showMvTitle', true);

          const floatBanner = document.getElementById('c-floating');
          const mainBody = document.querySelector('#p-lp');
          mainBody.style.visibility = 'visible';

          // navの固定
          ScrollTrigger.create({
            id: 'main',
            trigger: mainBody,
            // endTrigger: entry,
            end: 'bottom bottom',
            // toggleClass: 'is-nav-fixed',
            onEnterBack: () => {
              // endTriggerに戻る
              floatBanner.style.bottom = '';
              floatBanner.style.position = '';
            },
            onLeave: () => {
              // endTriggerを過ぎる
              // floatBanner.style.bottom = `${mainBody.getBoundingClientRect().height}px`;
              floatBanner.style.bottom = '0px';
              floatBanner.style.position = 'absolute';
            },
          });

          const rOvserver = new ResizeObserver(this.resize);
          rOvserver.observe(document.getElementById('p-lp'));

          const search = new URLSearchParams(window.location.search);
          if (search.get('anchor')) {
            if (document.querySelector('#' + search.get('anchor'))) {
              this.anchor(search.get('anchor'));
            }
          }

          // アンカーリンク
          document.querySelectorAll('.js-anchor-link').forEach((el) => {
            el.addEventListener('click', this.anchorLink)
          });
          
        },
        anchorLink(e) {
          e.preventDefault();
          if (e.target.hash) {
            this.anchor(e.target.hash.replace('#', ''));
          }
        },
        anchor(id) {
          gsap.to(window, { duration: 0.8, scrollTo: { y: `#${id}`, autoKill: false }, ease: Quart.easeInOut});
        },
        resize(entries) {
          if (this.$store.getters.showLoad) return;
          entries.forEach((entry) => {
              ScrollTrigger.refresh();
          });
        }
      }
    }

    // vue3
    const app = createApp(EventHandling);
    app.use(store);
    app.mount('#c-container');
  }

  start() {
    
  }

  // getHeight100() {
  //   const vh = window.innerHeight * 0.01;
  //   document.documentElement.style.setProperty('--vh', `${vh}px`);
  // }
}
